<template>
  <div class="portrait-alert-main" @click="close">
    <transition name="alert">
      <div class="box" @click.stop>
        <div class="title">添加头像</div>
        <div class="option">
          <div :class="[type === 1 ? 'active' : '']">1.选择图片</div>
          <div :class="[type === 2 ? 'active' : '']">2.剪裁图片</div>
        </div>
        <div v-show="type === 1">
          <div class="line"></div>
          <div class="up width-320">
            <input type="file" class="up-input" ref="upInput" @change="upInputChange">
            <div class="up-btn" @click="upButton">本地上传</div>
            <div class="up-msg">（最大不超过 {{this.maxImgSize/1024/1024}} M）</div>
          </div>
        </div>
        <div v-show="type === 2">
          <div class="up-box width-320">
            <vueCropper style="background: transparent;" ref="cropper" :img="option.img"
              :canMove="option.canMove"
              :autoCrop="option.autoCrop"
              :centerBox="option.centerBox"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"></vueCropper>
          </div>
          <div class="width-320 up-box-btn">
            <button @click="prev">上一步</button>
            <button class="active" @click="upload">完成</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import { routerTo, dealSignatrue } from '@/assets/js/util';

var { VueCropper } = require('vue-cropper')

export default {
  name: 'message',
  components: {
    VueCropper
  },
  data() {
    return {
      optionValue: 2,
      type: 1,
      option: {
        img: '', // 裁剪图片的地址
        // info: true, // 裁剪框的大小信息
        // outputSize: 0.8, // 裁剪生成图片的质量
        // outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        // fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1,1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        // canMoveBox: false, // 截图框能否拖动
        // original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      }
    };
  },
  props:{
    fixedNumber:{ //图片裁剪比例
      type: Array,
      default:()=>[1, 1]
    },
    maxImgSize:{ //最大上传图片大小（file表单）
      type: Number,
      default: 2*1024*1024
    },
  },
  created(){
    this.option.fixedNumber = this.fixedNumber;
  },
  mounted() {
    let dom = document.querySelectorAll('.portrait-alert-main .el-collapse-item__header');
    for (let i = 0; i < dom.length; i++) {
      let d = document.createElement('i');
      d.classList.add('iconfont', 'iconxiala');
      dom[i].appendChild(d);
    }
  },
  methods: {
    // 上传
    async upload() {
      this.$refs.cropper.getCropData(async file => {
        this.$emit('uploadConfirm',file);
        this.$refs.upInput.value = '';
      })
    },
    upInputChange(data) {
      let file = this.$refs.upInput.files;
      let fileType = file[0].type.toLowerCase();
      //判断文件类型
      if(!(fileType==='image/png' || fileType==='image/jpg' || fileType==='image/jpeg')){
        this.$message({
          message: '上传头像格式错误',
          type: 'warning'
        });
        this.$refs.upInput.value = '';
        return false;
      }
      //判断图片大小
      if(file[0].size> this.maxImgSize){
        this.$message({
          message: '上传头像大小超出限制',
          type: 'warning'
        });
        this.$refs.upInput.value = '';
        return false;
      }
      this.type = 2;
      const reader = new FileReader()
      reader.readAsDataURL(file[0])
      reader.onload = e => {
        this.option.img = e.currentTarget.result
      }
    },
    //上一步
    prev() {
      this.type = 1;
      this.$refs.upInput.value = '';
    },
    //点击上传图片
    upButton() {
      this.$refs.upInput.click();
    },
    //关闭
    close() {
      this.$emit('uploadState',false)
    },
  }
}
</script>
<style lang="scss" scoped>
  .portrait-alert-main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(0, 0, 0, .5);
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
    }
    .box {
      width: 560px;
      min-height: 200px;
      max-height: 825px;
      background: #fff;
      border-radius: 12px;
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      box-sizing: border-box;
      padding: 32px 24px;
      .title {
        font-size: 16px;
        color: #404040;
        margin-bottom: 24px;
        text-align: center;
      }
      .line {
        width: 100%;
        border-bottom: 1px solid #F4F4F4;
      }
      .option {
        display: flex;
        justify-content: center;
        align-items: center;
        &>div {
          color: #9C9C9C;
          font-size: 14px;
          padding-bottom: 14px;
          &:first-child {
            margin-right: 180px;
          }
          &.active {
            color: #404040;
            position: relative;
            &::after {
              content: "";
              display: block;
              width: 36px;
              height: 2px;
              background: #FF4F4C;
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
            }
          }
        }
      }
      .width-320 {
        width: 320px;
        margin: auto;
      }
      .up {
        height: 83px;
        display: flex;
        align-items: center;
        .up-btn {
          width: 120px;
          height: 32px;
          background:rgba(255,79,76,1);
          border-radius:2px;
          text-align: center;
          line-height: 32px;
          color: #fff;
          cursor: pointer;
        }
        .up-msg {
          color: #404040;
          font-size: 14px;
        }
        .up-input {
          width: 0;
          height: 0;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
        }
      }
      .up-box {
        // min-height: 300px;
        margin-top: 20px;
        width: 320px;
        height: 320px;
        img {
          max-width: 320px;
          max-height: 320px;
        }
      }
      .up-box-btn {
        margin-top: 20px;
        width: 400px;
        display: flex;
        justify-content: space-between;
        button {
          width: 150px;
          height: 40px;
          font-size: 14px;
          border: 1px solid #D9D9D9;
          color: #606060;
          &.active {
            background: #FF4F4C;
            border-color: #FF4F4C;
            color: #fff;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .portrait-alert-main {
    .el-collapse,
    .el-collapse-item__wrap,
    .el-collapse-item__header {
      border: none;
    }
    .el-collapse-item__arrow {
      display: none;
    }
    .el-collapse-item__header {
      justify-content: space-between;
      &.is-active {
        .iconfont {
          transform-origin: 50% 50%;
          transform: rotate(180deg);
        }
      }
    }
    .el-collapse {
      .iconfont {
        color: #9C9C9C;
        font-size: 10px;
        transition: all .3s ease;
      }
    }
    .cropper-box {
      background: #000;
    }
  }
</style>